import { debounceTime } from 'rxjs/operators';
import { Component, ElementRef, forwardRef, Input, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef, Output, EventEmitter, HostListener } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ClinicPatient, ClinicPatientService, DataSourceFilter, Filter } from '@meddatacore/shared';

@Component({
  selector: 'clinic-patient-search',
  templateUrl: './clinic-patient-search.component.html',
  styleUrls: ['./clinic-patient-search.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ClinicPatientSearchComponent),
    multi: true
  }]
})
export class ClinicPatientSearchComponent implements OnInit, ControlValueAccessor, AfterViewInit {
  _search_input: ElementRef
  @ViewChild('searchinput', { static: false }) set search_input(v: ElementRef) {
    this._search_input = v;
    this._search_input?.nativeElement.focus();
    this.changeDetector.detectChanges();
  };
  showSearch = false;
  inside = false;
  patients: ClinicPatient[] = []
  @Input() isLoading = false;
  patient: ClinicPatient;

  private _value;
  get value() {
    return this._value;
  }
  @Input()
  set value(val) {
    this._value = val;
    this.onChange(this._value);
  }
  private _height = 300;
  @Input()
  set height(v) {
    this._height = v;
  }
  get height() {
    return this._height;
  }
  @Input() limit: number = 10;
  get patientFullName() {
    if (this.patient?.id)
      return `${this.patient?.lastName} ${this.patient?.firstName} ${this.patient?.middleName}`;
    return '';
  }
  @Output() onInputTerm: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSelectPatient: EventEmitter<ClinicPatient> = new EventEmitter<ClinicPatient>();
  constructor(private patientService: ClinicPatientService, private changeDetector: ChangeDetectorRef, private _eref: ElementRef) { }
  ngAfterViewInit(): void {


  }
  // @HostListener("document:click", ['$event'])
  // clickout(event) {
  //   if (this.eRef.nativeElement.contains(event.target)) {
  //     this.inside = true;
  //     if (!this.showSearch) {
  //       this.showSearch = true;
  //     }
  //     console.log('inside')
  //   } else {
  //     this.inside = false;
  //     console.log('outside')
  //     if (this.showSearch) {
  //       this.showSearch = false;
  //     }
  //   }
  // }
  writeValue(value: any): void {
    this.value = value;
  }
  onChange(_: any) { }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    //throw new Error('Method not implemented.');
  }
  setDisabledState?(isDisabled: boolean): void {
    //throw new Error('Method not implemented.');
  }

  async ngOnInit(): Promise<void> {
    //this.patients = await this.getPatients();
  }
  search(e: any) {
    this.isLoading = true;
    let term = e.target.value;
    const terms_full_name = this.termToFullname(term);
    this.getPatients(terms_full_name).pipe(debounceTime(1000)).subscribe({
      next: (a) => {
        this.patients = a.data;
      }, error: () => {
        this.isLoading = false;
      }, complete: () => {
        this.isLoading = false;
      }
    });

    this.onInputTerm.emit(terms_full_name);
  }
  private termToFullname(term: string) {
    const [lastName, firstName, middleName] = term.split(' ').filter(a => !!a);
    return { lastName, firstName, middleName };
  }

  getPatients({ firstName, lastName, middleName }) {
    const queryParams = new DataSourceFilter();
    queryParams.filter.filters = [];
    //queryParams.filter.logic = "and";
    queryParams.page = 1;
    queryParams.pageSize = this.limit;
    if (lastName) {
      let orFilter = {} as Filter;
      orFilter.logic = "and"
      orFilter.filters = [];
      orFilter.filters.push({
        field: 'lastName', value: lastName, operator: 'contains'
      });
      if (middleName) {
        orFilter.filters.push({
          field: 'middleName', value: middleName, operator: 'contains'
        });
      } if (firstName) {
        orFilter.filters.push({
          field: 'firstName', value: firstName, operator: 'contains'
        });
      }
      queryParams.filter.filters.push(orFilter)
    }
    return this.patientService.getList(queryParams)
  }
  onSelect(e, item) {
    e.stopPropagation();
    this.patient = item;
    this.showSearch = false;
    this.value = item.id;
    this.onSelectPatient.emit(item);

    // this.changeDetector.markForCheck()
    // this.changeDetector.detectChanges()
  }
  clearValue(e) {
    e.stopPropagation();
    this.value = null;
    this.patient = null;
    this.showSearch = false;
    this.onSelectPatient.emit(null);
  }
  onclickSelectedInput() {
    this.showSearch = !this.showSearch;
    // this.patients=this.patients.filter(a=>a.id==this.patient.id)
    this.changeDetector.detectChanges();
  }
  closeSearch() {
    this.showSearch = false;
    //this.patient = null;
    // this.value = null;
  }

}
